import type { SVGProp } from './types';

export const twitter = (props: SVGProp) => (
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <path
      d="M16.5511 1.65576H19.6902L12.8338 9.5124L20.9003 20.2037H14.585L9.63848 13.7183L3.97816 20.2037H0.83781L8.17127 11.7996L0.433594 1.65576H6.91002L11.3807 7.58214L16.5511 1.65576ZM15.451 18.3207H17.1907L5.96343 3.4402H4.09841L15.451 18.3207Z"
      fill="currentColor"
    />
  </svg>
);
